type BookingId = string;

export const copyToClipboard = (booking_id: BookingId) => {
	/* Copy the text inside the text field */
	if (
		typeof window !== "undefined" &&
		typeof window.navigator !== "undefined" &&
		typeof window.navigator.clipboard !== "undefined"
	) {
		window.navigator.clipboard.writeText(booking_id).then(
			function () {
				// console.log(
				// 	"Async: Copying to clipboard was successful! " + booking_id,
				// );
			},
			function (err) {
				console.error("Async: Could not copy text: ", err);
				try {
					var successful = document.execCommand(booking_id);
					var msg = successful ? "successful" : "unsuccessful";
					;
				} catch (err) {
					;
				}
			},
		);
	} else {
		;
	}
};
